import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import styles from "./styles.module.scss";

// Icons
import { ReactComponent as BackIcon } from "assets/svg/BackPrimary.svg";
import { ReactComponent as DotsIcon } from "assets/svg/dots.svg";
import { ReactComponent as CardViewIcon } from "assets/svg/cardView.svg";
import { ReactComponent as ListViewIcon } from "assets/svg/listview.svg";
import { DownOutlined } from "@ant-design/icons";
import { ReactComponent as GoalIcon } from "assets/svg/goal.svg";
import { ReactComponent as ConnectIcon } from "assets/svg/connect.svg";
import { ReactComponent as Cross } from "assets/svg/closeBox.svg";
import { LoadingOutlined } from "@ant-design/icons";
import { ReactComponent as FilterIcon } from "assets/svg/filter.svg";
import { ReactComponent as Close } from "assets/svg/close.svg";
import { ReactComponent as ArrowDown } from "assets/svg/arrowDownGray.svg";
import { ReactComponent as AddIcon } from "assets/svg/plusBlue.svg";
import { ReactComponent as TrashFill } from "assets/svg/trashfill.svg";

import { ReactComponent as CompleteIcon } from "assets/svg/completeCircle.svg";
import { ReactComponent as InProgressIcon } from "assets/svg/inProgressCircle.svg";
import { ReactComponent as OnHoldIcon } from "assets/svg/onHoldOrange.svg";
import { ReactComponent as CancelIcon } from "assets/svg/cancelCircle.svg";
import { ReactComponent as TodoIcon } from "assets/svg/todoCircle.svg";

import { ReactComponent as RenameIcon } from "assets/svg/rename.svg";
import { ReactComponent as ArchiveIcon } from "assets/svg/archive.svg";
import { ReactComponent as DuplicateIcon } from "assets/svg/duplicate.svg";
import { ReactComponent as TrashICon } from "assets/svg/trashSmall.svg";
import { ReactComponent as ShareArrow } from "assets/svg/shareArrow.svg";
import { ReactComponent as DownloadIcon } from "assets/svg/download.svg";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  getPlanByID,
  updatePlan,
  updateViewType,
  updateViewTypeList,
} from "../../../modules/actions/PlanActions";

// Components
import DuplicateModal from "../../../components/duplicateModal";

import { durationList } from "constants";

// Antd
import { DatePicker, Dropdown, Modal, Popover, Select } from "antd";
const { Option } = Select;

// Moment
import moment from "moment";

// Components
import RoundedProgress from "../PlanHeader/components/RoundProgress";

// React Number Format
import { NumericFormat } from "react-number-format";

// Lodash
import debounce from "lodash.debounce";

// Components
import CustomDropdown from "../../../components/CustomDropdown/CustomDropdown";
import { getPath } from "../../../components/AppSwitcher";
import { ActionItemsModal } from "../../../components/ActionItemsModal";
import GoalSearch from "../../../components/GoalSearch";
import {
  actionItemFilterOptions,
  actionItemWeightOptions,
} from "../../ProjectPlanner/components/GoalSettings/data";

// Export
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { HeaderTemplate, BodyTemplate, FooterTemplate } from "./PDFTemplate";
import {
  getCustomUnitName,
  getUnit,
} from "../../ProjectPlanner/components/GoalSettings/utils";
import { formatDateToMMDDYYYY } from "../../../utils/helper";

// Define empty filters constant
const EMPTY_FILTERS = Object.freeze({
  status: [],
  weight: [],
  progress: [],
  startDate: null,
  dueDate: null,
  weeklyDuration: [],
  assignedTo: [],
});

const PlanNewHeader = ({
  isShared,
  handleUpdate,
  handleChange,
  handleArchiveModal,
  handleRemoveModal,
  handleUpdateGoal,
  setIsExpandAllNotes,
  isExpandAllNotes,
  isListView,
  setIsListView,
  filterBy,
  setFilterBy,
  isMetricLoading,
}) => {
  const navigate = useNavigate();

  const { id } = useParams();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const goalRef = useRef(null);
  const { gpsURL } = getPath();

  const $objectiveRef = useRef(null);
  const $purposeRef = useRef(null);
  const $saveRef = useRef(null);
  const $buttonsRef = useRef([]);

  const [search, setSearch] = useState("");
  const [isFilter, setIsFilter] = useState(false);
  const [isNewFilter, setIsNewFilter] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);

  const [pdfLoading, setPdfLoading] = useState(false);

  const [activeTextTab, setActiveTextTab] = useState(1);
  const [textEdit, setTextEdit] = useState(false);

  const [selectedGoal, setSelectedGoal] = useState(null);
  const [isGoalSelect, setIsGoalSelect] = useState(false);
  const [isGoalModel, setIsGoalModel] = useState(false);
  const [goalName, setGoalName] = useState("");
  const [duplicateModal, setDuplicateModal] = useState(false);

  const [start, setStartCopy] = useState("");
  const [current, setCurrentCopy] = useState("");
  const [target, setTargetCopy] = useState("");
  const [placeholderStart, setPlaceholderStart] = useState("--");
  const [placeholderCurrent, setPlaceholderCurrent] = useState("--");
  const [placeholderTarget, setPlaceholderTarget] = useState("--");

  const [objectiveCopy, setObjectiveCopy] = useState("");
  const [purposeCopy, setPurposeCopy] = useState("");
  const [searchGoal, setSearchGoal] = useState("");

  const [filters, setFilters] = useState({ ...EMPTY_FILTERS });

  const { user } = useSelector((state) => state.auth);

  const userId =
    user?.data?.external_accounts?.find(
      (account) => account.decision_and_project
    )?.decision_and_project ?? null;

  const {
    planDetails,
    allGoalList,
    selectedGoalList,
    loadingUpdatePlan,
    viewTypeList,
  } = useSelector((state) => state.plan.plan);
  const title = planDetails?.name;

  const { users: planUsers } = useSelector((state) => state.user.projectOwners);

  const AssignOptions = planUsers?.map((user) => ({
    label: user.email,
    value: user.id,
    initials: user.name
      ? user.name.match(/\b\w/g).join("")
      : user.email[0].toUpperCase(),
  }));

  const selectedAssignee = planUsers?.find(
    (option) => option.email === filters?.assignedTo?.label
  );

  const userName =
    selectedAssignee?.first_name && selectedAssignee?.last_name
      ? selectedAssignee?.first_name.substring(0, 1) +
        selectedAssignee?.last_name.substring(0, 1)
      : selectedAssignee?.name
      ? selectedAssignee?.name.split(" ").length > 1
        ? selectedAssignee.name.split(" ")[0].substring(0, 1) +
          selectedAssignee.name.split(" ")[1].substring(0, 1)
        : selectedAssignee.name.substring(0, 2)
      : selectedAssignee?.email?.substring(0, 2);

  const isTrueOwner = user?.email === planDetails?.invited_owner;
  const onwer = planDetails?.owner == userId;
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    setObjectiveCopy(planDetails?.objective);
    setPurposeCopy(planDetails?.purpose);
  }, [planDetails?.objective, planDetails?.purpose]);

  const debouncedHandleUpdateGoal = useCallback(
    debounce((field, value) => {
      handleUpdateGoal(field, value);
    }, 500),
    []
  );

  useEffect(() => {
    if (planDetails?.goal) {
      setStartCopy(planDetails?.goal?.start?.toString() ?? "");
      setCurrentCopy(planDetails?.goal?.current?.toString() ?? "");
      setTargetCopy(planDetails?.goal?.target?.toString() ?? "");
    }
  }, []);

  const onChangeHandle = (field, value) => {
    if (field === "start") setStartCopy(value);
    else if (field === "current") setCurrentCopy(value);
    else if (field === "target") setTargetCopy(value);

    if (value && !isNaN(value)) {
      debouncedHandleUpdateGoal(field, value);
    } else {
      debouncedHandleUpdateGoal(field, null);
    }
  };

  const disabledGoalInput = isShared || planDetails?.goal?.metric_unit === null && planDetails?.goal?.custom_unit === null;

  const onObjectiveBlurHandle = (evt) => {
    if (isShared) return;

    handleUpdate("objective", objectiveCopy);

    if (evt.relatedTarget !== $saveRef.current) {
      setTextEdit(false);
    }
  };

  const onPurposeBlurHandle = (evt) => {
    if (isShared) return;
    handleUpdate("purpose", purposeCopy);

    if (evt.relatedTarget !== $saveRef.current) {
      setTextEdit(false);
    }
  };

  const getMenuProps = (item) => ({
    className: "removeOption",
    items: [
      {
        key: "1",
        onClick: () => {
          handleChange("renamePlanModal", true);
          handleChange("planName", item?.name);
        },
        label: (
          <span className={styles.menuItem}>
            <RenameIcon /> Rename
          </span>
        ),
      },
      {
        key: "2",
        onClick: () => {
          setDuplicateModal(true);
        },
        label: (
          <span className={styles.menuItem}>
            <DuplicateIcon /> Duplicate Plan
          </span>
        ),
      },
      {
        key: "3",
        onClick: handleArchiveModal,
        label: (
          <span className={styles.menuItem}>
            <ArchiveIcon />
            Archive Plan
          </span>
        ),
      },
      {
        key: "4",
        onClick: handleShare,
        disabled: item?.is_archived,
        label: (
          <span className={styles.menuItem}>
            <ShareArrow />
            Share
          </span>
        ),
      },
      {
        key: "5",
        onClick: handleRemoveModal,
        label: (
          <span className={styles.deleteItem}>
            <TrashICon />
            Delete Project
          </span>
        ),
      },
    ],
  });

  const handleShare = () => {
    navigate(`/project-planner/plan-details/${planDetails?.id}/resources`);
  };

  const handleCopyChange = (event, setValue, maxLength = 256) => {
    let input = event.target.value;

    if (input.length > maxLength) {
      input = input.slice(0, maxLength);
    }

    setValue(input);
  };

  const navTabs = [
    {
      id: "1",
      visible: true,
      text: "Action Items",
      to: `/project-planner/plan-details/${planDetails?.id}`,
    },
    {
      id: "2",
      visible: !isShared,
      text: "Project Plan Details",
      to: `/project-planner/plan-details/${planDetails?.id}/details`,
    },
    {
      id: "3",
      visible: !isShared,
      text: "Resources",
      to: `/project-planner/plan-details/${planDetails?.id}/resources`,
    },
    {
      id: "4",
      visible: !isShared,
      text: "Project Insights",
      to: `/project-planner/plan-details/${planDetails?.id}/insights`,
    },
  ];

  // Handle click outside
  const handleClickOutside = (event) => {
    if (
      !$objectiveRef.current?.contains(event.target) &&
      !$purposeRef.current?.contains(event.target) &&
      !$buttonsRef.current?.some((ref) => ref.contains(event.target))
    ) {
      setTextEdit(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (goalRef.current && !goalRef.current.contains(event.target)) {
        setIsGoalSelect(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [goalRef]);

  useEffect(() => {
    if (selectedGoalList && planDetails?.goal_public_id) {
      setSelectedGoal({
        id: selectedGoalList?.id,
        goal_name: selectedGoalList?.goal_name,
        type: selectedGoalList?.goal?.type,
      });
    }
  }, [selectedGoalList]);

  const handleSearch = (evt) => {
    setSearch(evt.target.value);
  };

  const handleClose = () => {
    setIsGoalModel(false);
    setGoalName("");
    setSelectedGoal({
      id: selectedGoalList?.id,
      goal_name: selectedGoalList?.goal_name,
      type: selectedGoalList?.goal?.type,
    });
  };

  const handleConnect = () => {
    const rest = {
      goal_public_id: selectedGoal?.id || "null",
    };
    dispatch(updatePlan(id, rest, () => {
      handleClose();
      dispatch(getPlanByID(id));
    }, true));
  };

  const filterGoalList = allGoalList?.filter((goal) =>
    goal?.goal_name.toLowerCase().includes(searchGoal.toLowerCase())
  );

  const handleCollageNotes = () => {
    setIsExpandAllNotes(!isExpandAllNotes);
  };

  const removeFilterOption = actionItemFilterOptions.filter(
    (option) => !selectedFilters.some((filter) => filter.value === option.value)
  );

  const StatusOptions = [
    {
      label: "To Do",
      value: 1,
      icon: <TodoIcon />,
    },
    {
      label: "In Progress",
      value: 2,
      icon: <InProgressIcon />,
    },
    {
      label: "On Hold",
      value: 3,
      icon: <OnHoldIcon />,
    },
    {
      label: "Completed",
      value: 4,
      icon: <CompleteIcon />,
    },
    {
      label: "Cancelled",
      value: 5,
      icon: <CancelIcon />,
    },
  ];

  const handleApply = () => {
    // Make a copy of the filters to ensure arrays are properly handled
    const appliedFilters = {
      status:
        filters.status && filters.status.length > 0 ? [...filters.status] : [],
      weight:
        filters.weight && filters.weight.length > 0 ? [...filters.weight] : [],
      progress:
        filters.progress && filters.progress.length > 0
          ? [...filters.progress]
          : [],
      startDate: filters.startDate,
      dueDate: filters.dueDate,
      weeklyDuration:
        filters.weeklyDuration && filters.weeklyDuration.length > 0
          ? [...filters.weeklyDuration]
          : [],
      assignedTo:
        filters.assignedTo && filters.assignedTo.length > 0
          ? [...filters.assignedTo]
          : [],
    };
    setFilterBy(appliedFilters);
    setIsFilter(false);
  };

  const hasActiveFilters = () => {
    const hasChanges = () => {
      const arraysEqual = (arr1, arr2) => {
        const isEmpty1 = !arr1 || (Array.isArray(arr1) && arr1.length === 0);
        const isEmpty2 = !arr2 || (Array.isArray(arr2) && arr2.length === 0);
        if (isEmpty1 && isEmpty2) return true;
        if (isEmpty1 || isEmpty2) return false;
        if (arr1.length !== arr2.length) return false;
        return arr1.every((val, index) => val === arr2[index]);
      };

      const assignedToEqual = (arr1, arr2) => {
        const isEmpty1 = !arr1 || (Array.isArray(arr1) && arr1.length === 0);
        const isEmpty2 = !arr2 || (Array.isArray(arr2) && arr2.length === 0);
        if (isEmpty1 && isEmpty2) return true;
        if (isEmpty1 || isEmpty2) return false;
        if (arr1.length !== arr2.length) return false;
        return arr1.every((user1, index) => user1.value === arr2[index]?.value);
      };

      return (
        !arraysEqual(filters.status, filterBy.status) ||
        !arraysEqual(filters.weight, filterBy.weight) ||
        !arraysEqual(filters.progress, filterBy.progress) ||
        !arraysEqual(filters.weeklyDuration, filterBy.weeklyDuration) ||
        !assignedToEqual(filters.assignedTo, filterBy.assignedTo) ||
        filters.startDate !== filterBy.startDate ||
        filters.dueDate !== filterBy.dueDate
      );
    };

    return hasChanges();
  };

  const mapFiltersToOptions = (filters) => {
    return Object.keys(filters)
      .filter((key) => {
        if (Array.isArray(filters[key])) {
          return filters[key].length > 0;
        }
        return filters[key] !== null;
      })
      .map((key) => {
        const option = actionItemFilterOptions.find((opt) => opt.value === key);
        return option ? { ...option, selectedValue: filters[key] } : null;
      })
      .filter(Boolean);
  };

  const handleResetFilter = () => {
    setSelectedFilters([]);
    setIsNewFilter(true);
    setFilters({ ...EMPTY_FILTERS });
    setFilterBy({ ...EMPTY_FILTERS });
  };

  const exportAsCSV = (exportData) => {
    const escapeCSVValue = (value) => {
      const strValue =
        value === null || value === undefined ? "" : value.toString();
      return `"${strValue.replace(/"/g, '""')}"`;
    };

    const formatWeight = (weight) => {
      if (weight === null || weight === undefined || isNaN(weight)) return "";
      let num = Number(weight);
      if (num <= 1) {
        num = num * 100;
      }
      return `${parseFloat(num.toFixed(2))}`;
    };

    // Format a value as a percent string (e.g., 0.5 -> "50%", 50 -> "50%")
    const toPercent = (value) => {
      if (value === null || value === undefined || isNaN(value)) return "";
      let num = Number(value);
      if (num <= 1) {
        num = num * 100;
      }
      return `${parseFloat(num.toFixed(2))}%`;
    };

    // Plan Details section
    const planDetailsSection = [
      "Plan_Details,,,,,,,,,,,,,,,",
      "Name,Start Date,End Date,Status,Purpose,Objective,Idea,Description,Start,Current,Target,Plan Progress,Goal Progress,Metric,,",
      [
        exportData.name,
        exportData.start_line,
        exportData.dead_line,
        exportData.status === "in_progress"
          ? "In Progress"
          : exportData.status === "on_hold"
          ? "On Hold"
          : exportData.status === "completed"
          ? "Completed"
          : exportData.status === "scheduled"
          ? "Scheduled"
          : exportData.status,
        exportData.purpose || "",
        exportData.objective || "",
        exportData.idea || "",
        exportData.description || "",
        exportData.start || "",
        exportData.current || "",
        exportData.target || "",
        toPercent(exportData.planProgress),
        toPercent(exportData.goalProgress),
        exportData.metric || "",
        "",
        "",
      ]
        .map(escapeCSVValue)
        .join(","),
      ",,,,,,,,,,,,,,,",
      " ,,,,,,,,,,,,,,,",
    ];

    // Criteria Tags section
    const criteriaTagsSection = [
      "Criteria Tags,,,,,,,,,,,,,,,",
      "Name,Weight,Color,,,,,,,,,,,,,",
      ...(exportData.criteria_tags && exportData.criteria_tags.length > 0
        ? exportData.criteria_tags.map((tag) =>
            [
              tag.name || "",
              tag.weight !== undefined ? tag.weight : "",
              tag.color || "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
            ]
              .map(escapeCSVValue)
              .join(",")
          )
        : [",,,,,,,,,,,,,,,"]),
      ",,,,,,,,,,,,,,,",
      " ,,,,,,,,,,,,,,,",
    ];

    // People section
    const peopleSection = [
      "People,,,,,,,,,,,,,,,",
      "ID,Name,Email,Username,First Name,Last Name,,,,,,,,,,",
      ...(exportData.resource && exportData.resource.people && exportData.resource.people.length > 0
        ? exportData.resource.people.map(person => [
            person.id || "",
            person.name || "",
            person.email || "",
            person.username || "",
            person.f_name || "",
            person.l_name || "",
            "", "", "", "", "", "", "", "", "", ""
          ].map(escapeCSVValue).join(","))
        : [",,,,,,,,,,,,,,,"]),
      ",,,,,,,,,,,,,,,",
      " ,,,,,,,,,,,,,,,",
    ];

    // Tools section
    const toolsSection = [
      "Tools,,,,,,,,,,,,,,,",
      "ID,Name,Created At,,,,,,,,,,,,,",
      ...(exportData.resource &&
      exportData.resource.tools &&
      exportData.resource.tools.length > 0
        ? exportData.resource.tools.map((tool) =>
            [
              tool.id || "",
              tool.name || "",
              tool.created_at || "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
            ]
              .map(escapeCSVValue)
              .join(",")
          )
        : [",,,,,,,,,,,,,,,"]),
      ",,,,,,,,,,,,,,,",
      " ,,,,,,,,,,,,,,,",
    ];

    // Categories and Action Items section
    const categoriesSection = [
      "Categories and Action Items,,,,,,,,,,,,,,,",
      "Category,Category Weight,Action Item,Weight,Plan Progress,Status,Start Date,Due Date,Duration,Assignee (Email),Measurement Label,Measurement Unit,Start,Current,Target,",
      " ,,,,,,,,,,,,,,,",
      ...exportData.categories.flatMap((category) =>
        category.action_items.map((item) =>
          [
            category.name,
            toPercent(category.weight),
            item.name,
            formatWeight(item.weight),
            formatWeight(item.plan_progress),
            item.status === 1
              ? "Todo"
              : item.status === 2
              ? "In Progress"
              : item.status === 3
              ? "On Hold"
              : item.status === 4
              ? "Completed"
              : "Cancelled",
            item.start_line,
            item.dead_line,
            item.duration,
            item.responsible_person || "",
            item.measurement_label,
            item.measurement_unit,
            item.start,
            item.current,
            item.target,
          ]
            .map(escapeCSVValue)
            .join(",")
        )
      ),
    ];

    const csvContent = [
      ...planDetailsSection,
      ...criteriaTagsSection,
      ...peopleSection,
      ...toolsSection,
      ...categoriesSection,
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${exportData.name}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleExportCSV = () => {
    const exportData = {
      name: planDetails?.name,
      start_line: planDetails?.start_line,
      dead_line: planDetails?.dead_line,
      status: planDetails?.status,
      purpose: planDetails?.purpose,
      objective: planDetails?.objective,
      idea: planDetails?.idea,
      description: planDetails?.description,
      start: planDetails?.goal?.start?.toString(),
      current: planDetails?.goal?.current?.toString(),
      target: planDetails?.goal?.target?.toString(),
      goalProgress: planDetails?.goal?.progress?.toString(),
      planProgress: planDetails?.plan_progress?.toString(),
      metric: planDetails?.goal?.metric_unit_detail?.name || "",
      criteria_tags: planDetails?.criteria_tags || [],
      resource: planDetails?.resource || {},
      categories: planDetails?.categories?.map((category) => ({
        name: category?.name,
        weight: category?.weight,
        color: category?.color,
        category_progress: category?.category_progress,
        start_line: category?.start_line,
        dead_line: category?.dead_line,
        action_items: category?.action_items?.map((item) => ({
          name: item?.name,
          weight: item?.weight,
          status: item?.status,
          priority: item?.priority,
          start_line: formatDateToMMDDYYYY(item?.start_line),
          dead_line: formatDateToMMDDYYYY(item?.dead_line),
          plan_progress: item?.plan_progress,
          duration: item?.duration,
          description: item?.description,
          responsible_person: item?.responsible_person?.email,
          measurement_label: item?.metric_label,
          measurement_unit: item?.label
            ? item[getUnit(item?.label)]
            : item?.metric_unit_name,
          start: item?.start,
          current: item?.current,
          target: item?.target,
        })),
      })),
    };

    exportAsCSV(exportData);
    setDropdownOpen(false);
  };

  const handleExportPDF = async () => {
    if (pdfLoading) return;
    setPdfLoading(true);
    const metric = getCustomUnitName(planDetails);

    try {
      // Calculate total rows and pages
      let totalRows = 0;
      planDetails?.categories?.forEach((category) => {
        totalRows++;
        totalRows += category.action_items?.length || 0;
      });

      const onwer = planDetails?.resource?.people?.find(
        (person) => person.id === planDetails?.owner
      );

      const remainingRows = totalRows - 13; // Rows after first page
      const additionalPages = Math.ceil(Math.max(0, remainingRows) / 16);
      const totalPages = 1 + additionalPages;

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      // Generate PDF pages
      for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
        const containerElement = document.createElement("div");
        containerElement.style.width = "1400px";
        containerElement.style.backgroundColor = "#ffffff";
        containerElement.style.position = "absolute";
        containerElement.style.left = "-9999px";
        containerElement.style.top = "-9999px";

        const content = `
          <div style="width: 1400px; background-color: #ffffff; padding: 40px 0px;">
            ${HeaderTemplate(planDetails, metric)}
            ${BodyTemplate(planDetails, metric, pageNumber)}
            ${FooterTemplate(planDetails, pageNumber, totalPages, onwer)}
          </div>
        `;

        containerElement.innerHTML = content;
        document.body.appendChild(containerElement);

        await new Promise((resolve) => setTimeout(resolve, 500));

        try {
          const canvas = await html2canvas(containerElement, {
            scale: 1,
            useCORS: true,
            logging: true,
            backgroundColor: "#ffffff",
            width: 1400,
            height: containerElement.offsetHeight,
            windowWidth: 1400,
            onclone: (document) => {
              document.fonts.ready.then(() => {
                console.log("Fonts loaded");
              });
            },
          });

          const imgData = canvas.toDataURL("image/png", 1.0);
          const imgWidth = 210;
          const pageHeight = 297;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;

          if (pageNumber > 1) {
            pdf.addPage();
          }

          pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
        } catch (error) {
          console.error(`Error processing page ${pageNumber}:`, error);
        } finally {
          document.body.removeChild(containerElement);
        }
      }

      pdf.save(`${planDetails?.name || "Project Plan"}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setPdfLoading(false);
      setDropdownOpen(false);
    }
  };

  const exportItems = [
    {
      key: "pdf",
      label: "Export as PDF",
      icon: pdfLoading ? <LoadingOutlined /> : <DownloadIcon />,
      onClick: handleExportPDF,
      loading: pdfLoading,
    },
    {
      key: "csv",
      label: "Export as CSV",
      icon: <DownloadIcon />,
      onClick: handleExportCSV,
    },
  ];

  const handleDuplicateModal = () => {
    setDuplicateModal(false);
  };

  const handleViewTypeChange = (viewType, isListView) => {
    if (isShared) {
      setIsListView(isListView);
      return;
    }

    setIsListView(isListView);
    dispatch(updateViewType(planDetails?.id, { view_type: viewType }));

    const existingItem = viewTypeList?.find(
      (item) => item?.id === planDetails?.id
    );

    if (existingItem) {
      dispatch(
        updateViewTypeList(
          viewTypeList.map((item) =>
            item.id === planDetails?.id
              ? { ...item, view_type: viewType }
              : item
          )
        )
      );
    } else {
      dispatch(
        updateViewTypeList([
          ...viewTypeList,
          {
            id: planDetails?.id,
            view_type: viewType,
          },
        ])
      );
    }
  };

  return (
    <>
      <Modal
        footer={null}
        closable={false}
        title={false}
        open={isGoalModel}
        centered
        width={520}
        className="disablePadding"
      >
        <div className={styles.connectModel}>
          <div className={styles.modelHeader}>
            <h3>Connect Goal</h3>
            <Cross className={"c-pointer"} onClick={handleClose} />
          </div>

          <div className={styles.main}>
            <h4 className={styles.sureText}>
              Are you sure you want to connect the following goal with your
              project?
            </h4>

            <div className={styles.goal_content}>
              <label>Goal Name</label>

              <h4>
                {goalName || selectedGoal?.goal_name || "No Goal Connected"}
              </h4>
            </div>
          </div>

          <div className={styles.actions}>
            <button onClick={handleClose}>Cancel</button>
            <button onClick={handleConnect} disabled={loadingUpdatePlan}>
              {loadingUpdatePlan ? <LoadingOutlined /> : "Connect"}
            </button>
          </div>
        </div>
      </Modal>

      <DuplicateModal
        visible={duplicateModal}
        handleCloseModal={handleDuplicateModal}
      />

      <div className={styles.planHeader}>
        <div className={styles.planHeader_title}>
          <div className={styles.planHeader_title_text}>
            {!isShared && (
              <Link className={styles.back} to="/project-planner/">
                <BackIcon
                  style={{
                    cursor: "pointer",
                    marginTop: "-2px",
                  }}
                />
              </Link>
            )}

            <h3>PROJECT</h3>
          </div>
          <div className={styles.planHeader_items}>
            <Dropdown
              menu={{ items: exportItems }}
              trigger={["click"]}
              placement="bottomRight"
              open={dropdownOpen}
              overlayClassName="exportDropdown"
              onOpenChange={setDropdownOpen}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              <div className={styles.action}>
                <DownloadIcon />
                EXPORT
              </div>
            </Dropdown>

            {/* <Link
            className={styles.action}
            to={`/project-planner/plan-details/${planDetails?.id}/resources`}
          >
            <ShareGray />
            SHARE
          </Link> */}
          </div>
        </div>

        <div className={styles.planHeader_details}>
          <div className={styles.planHeader_details_left}>
            <div className={styles.title}>
              <h2 className="text-oneline">{title}</h2>

              {!isShared && (
                <Dropdown menu={getMenuProps(planDetails)} trigger={["click"]}>
                  <button type="button" className={styles.settings}>
                    <DotsIcon />
                  </button>
                </Dropdown>
              )}
            </div>

            <h6 className={styles.deadline}>
              Deadline:
              <span>
                <span>
                  {planDetails?.dead_line &&
                  moment(planDetails?.dead_line).isValid()
                    ? moment(planDetails?.dead_line).format("MM/DD/YYYY")
                    : "Set Dates"}
                </span>
              </span>
            </h6>

            <div className={styles.objectiveButtons}>
              <button
                ref={(el) => ($buttonsRef.current[0] = el)}
                className={activeTextTab === 1 ? styles.active : ""}
                type="button"
                onClick={() => {
                  setActiveTextTab(1);
                  if (!isShared) {
                    setTextEdit(true);
                  }
                }}
              >
                Objective
              </button>
              <button
                ref={(el) => ($buttonsRef.current[1] = el)}
                className={activeTextTab === 2 ? styles.active : ""}
                type="button"
                onClick={() => {
                  setActiveTextTab(2);
                  if (!isShared) {
                    setTextEdit(true);
                  }
                }}
              >
                Purpose
              </button>
            </div>

            <div className={styles.objectiveTextarea}>
              {activeTextTab === 1 && (
                <textarea
                  ref={$objectiveRef}
                  value={objectiveCopy || ""}
                  onChange={(event) =>
                    handleCopyChange(event, setObjectiveCopy, 500)
                  }
                  onBlur={onObjectiveBlurHandle}
                  name={"name"}
                  readOnly={!textEdit}
                />
              )}

              {activeTextTab === 2 && (
                <textarea
                  ref={$purposeRef}
                  value={purposeCopy || ""}
                  onChange={(event) =>
                    handleCopyChange(event, setPurposeCopy, 500)
                  }
                  onBlur={onPurposeBlurHandle}
                  name={"purpose"}
                  readOnly={!textEdit}
                />
              )}
            </div>
          </div>
          <div className={styles.planHeader_details_right}>
            <div className={styles.goalItem}>
              <div className={styles.goalItem_content}>
                {selectedGoalList?.goal_name ? (
                  <h4 className="text-oneline">
                    {selectedGoalList?.goal_name}
                  </h4>
                ) : (
                  <h2>No Goal Connected</h2>
                )}

                <div ref={goalRef} className={styles.goal_input_wrapper}>
                  <div>
                    {selectedGoalList?.goal_name ? (
                      <h6
                        onClick={() => {
                          onwer &&
                            window.open(
                              `https://${gpsURL}/journeys/action-plans?j=${selectedGoalList?.journey}&g=${selectedGoalList?.id}&m=${selectedGoalList?.master_plan_id}/`,
                              "_blank"
                            );
                        }}
                      >
                        <GoalIcon />
                        See Goal
                      </h6>
                    ) : (
                      <h6
                        onClick={() => {
                          onwer && setIsGoalSelect(!isGoalSelect);
                        }}
                      >
                        <ConnectIcon />
                        Connect Goal
                      </h6>
                    )}
                  </div>

                  <GoalSearch
                    goalRef={goalRef}
                    allGoalList={allGoalList}
                    isGoalSelect={isGoalSelect}
                    setIsGoalSelect={setIsGoalSelect}
                    setSelectedGoal={setSelectedGoal}
                    setGoalName={setGoalName}
                    setIsGoalModel={setIsGoalModel}
                    onwer={onwer}
                    isHeader={true}
                  />
                </div>
              </div>
              <div className={styles.goalItem_metric}>
                <div className={styles.goalItem_select}>
                  <label>Metric</label>

                  <CustomDropdown
                    handleUpdateGoal={handleUpdateGoal}
                    planDetails={planDetails}
                    disabled={isShared}
                    handleChange={handleChange}
                  />
                </div>

                <div className={styles.goalItem_input}>
                  <label>
                    Start
                    {isMetricLoading.start && <LoadingOutlined />}
                  </label>
                  <NumericFormat
                    name="start"
                    value={start === "0.00" || start === "0" ? "0.00" : start}
                    decimalScale={2}
                    fixedDecimalScale
                    disabled={disabledGoalInput}
                    onChange={(evt) =>
                      onChangeHandle("start", evt.target.value)
                    }
                    onFocus={() => setPlaceholderStart("")}
                    onBlur={() => setPlaceholderStart("--")}
                    placeholder={placeholderStart}
                    className={styles.goalItem_metric_input}
                  />
                </div>
                <div className={styles.goalItem_input}>
                  <label>
                    Current
                    {isMetricLoading.current && <LoadingOutlined />}
                  </label>
                  <NumericFormat
                    name="current"
                    value={
                      current === "0.00" || current === "0" ? "0.00" : current
                    }
                    decimalScale={2}
                    fixedDecimalScale
                    disabled={disabledGoalInput}
                    onChange={(evt) =>
                      onChangeHandle("current", evt.target.value)
                    }
                    onFocus={() => setPlaceholderCurrent("")}
                    onBlur={() => setPlaceholderCurrent("--")}
                    placeholder={placeholderCurrent}
                    className={styles.goalItem_metric_input}
                  />
                </div>
                <div className={styles.goalItem_input}>
                  <label>
                    Target
                    {isMetricLoading.target && <LoadingOutlined />}
                  </label>
                  <NumericFormat
                    name="target"
                    value={
                      target === "0.00" || target === "0" ? "0.00" : target
                    }
                    decimalScale={2}
                    fixedDecimalScale
                    allowemptyformatting="true"
                    disabled={disabledGoalInput}
                    onChange={(evt) =>
                      onChangeHandle("target", evt.target.value)
                    }
                    onFocus={() => setPlaceholderTarget("")}
                    onBlur={() => setPlaceholderTarget("--")}
                    placeholder={placeholderTarget}
                    className={styles.goalItem_metric_input}
                  />
                </div>
              </div>
            </div>

            <div className={styles.progress}>
              <RoundedProgress
                size={100}
                progress={(
                  Number(planDetails?.goal?.progress || 0) * 100
                ).toFixed(0)}
                label={"Goal Progress"}
                strokeWidth={7}
                innerStrokeWidth={7}
                circleTwoStroke="#FF9900"
                circleOneStroke="#E5E5E5"
                fill="transparent"
              />

              <RoundedProgress
                size={100}
                progress={(
                  Number(planDetails?.plan_progress || 0) * 100
                ).toFixed(0)}
                label={"Plan Progress"}
                strokeWidth={7}
                innerStrokeWidth={7}
                circleTwoStroke="#89C740"
                circleOneStroke="#E5E5E5"
                fill="transparent"
              />
            </div>
          </div>
        </div>

        <div className={styles.planHeader_actions}>
          <div className={styles.navWrapper}>
            {navTabs
              .filter((tab) => tab.visible)
              .map((tab) => (
                <Link
                  key={tab.id}
                  to={tab.to}
                  className={`${isShared ? styles.disabled : ""} ${
                    pathname.replace(/\/$/, "") === tab.to.replace(/\/$/, "") ||
                    isShared
                      ? styles.active
                      : ""
                  }`}
                >
                  {tab.text}
                </Link>
              ))}
          </div>

          <div className={styles.planHeader_options}>
            <Dropdown
              overlayClassName="listAndCardView_dropdown"
              menu={{
                items: [
                  {
                    label: "List View",
                    icon: <ListViewIcon />,
                    onClick: () => handleViewTypeChange(1, true),
                  },
                  {
                    label: "Card View",
                    icon: <CardViewIcon />,
                    onClick: () => handleViewTypeChange(2, false),
                  },
                ],
              }}
              trigger={["click"]}
              showArrow={true}
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              <span className={styles.view}>
                {isListView ? <ListViewIcon /> : <CardViewIcon />}{" "}
                {isListView ? "List View" : "Card View"}
                <DownOutlined />
              </span>
            </Dropdown>

            <Popover
              content={
                <>
                  <div className={styles.filterContainer} id="filter-container">
                    <div className={styles.filterHeader}>
                      <h3>Filters</h3>
                      <Close
                        className="cursor-pointer"
                        width={16}
                        height={16}
                        onClick={() => {
                          // Reset all filters
                          setSelectedFilters([]);
                          setIsNewFilter(true);
                          setFilters({ ...EMPTY_FILTERS });
                          setFilterBy({ ...EMPTY_FILTERS });
                          // Close filter panel
                          setIsFilter(false);
                        }}
                      />
                    </div>

                    <div className={styles.filterContain}>
                      {selectedFilters.map((filter, index) => (
                        <div className={styles.filterSelected_box} key={index}>
                          <div className={styles.filterSelected_header}>
                            <label htmlFor="">{filter?.label}</label>

                            <TrashFill
                              className="cursor-pointer"
                              onClick={() => {
                                setSelectedFilters(
                                  selectedFilters.filter(
                                    (selectedFilter) =>
                                      selectedFilter.value !== filter.value
                                  )
                                );

                                setFilters({
                                  ...filters,
                                  [filter.value]: null,
                                });
                              }}
                            />
                          </div>
                          {filter?.value === "status" ? (
                            <div className={styles.filterSelected_content}>
                              <Select
                                suffixIcon={<ArrowDown />}
                                className={styles.filterSelect}
                                placeholder="Select status"
                                getPopupContainer={(trigger) => trigger.closest(".criteria_popover")?.parentElement}
                                mode="multiple"
                                onChange={(value) => {
                                  if (value && value.length > 0) {
                                    setFilters({
                                      ...filters,
                                      status: value,
                                    });
                                  } else {
                                    setFilters({
                                      ...filters,
                                      status: [],
                                    });
                                  }
                                }}
                                value={filters?.status}
                              >
                                {StatusOptions.map((option, index) => (
                                  <Select.Option
                                    key={index}
                                    value={option.value}
                                    label={option.label}
                                  >
                                    <span
                                      style={{
                                        marginRight: "5px",
                                      }}
                                    >
                                      {option.icon}{" "}
                                    </span>
                                    {option.label}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                          ) : filter?.value === "startDate" ? (
                            <div className={styles.filterSelected_content}>
                              <DatePicker
                                className={styles.filterSelect}
                                getPopupContainer={(trigger) => trigger.closest(".criteria_popover")?.parentElement}
                                placeholder="Select Start Date"
                                onChange={(date, dateString) => {
                                  if (dateString) {
                                    setFilters({
                                      ...filters,
                                      startDate: dateString,
                                    });
                                  } else {
                                    setFilters({
                                      ...filters,
                                      startDate: null,
                                    });
                                  }
                                }}
                                value={
                                  filters?.startDate
                                    ? moment(filters?.startDate)
                                    : null
                                }
                              />
                            </div>
                          ) : filter?.value === "dueDate" ? (
                            <div className={styles.filterSelected_content}>
                              <DatePicker
                                className={styles.filterSelect}
                                getPopupContainer={(trigger) => trigger.closest(".criteria_popover")?.parentElement}
                                placeholder="Select Due Date"
                                onChange={(date, dateString) => {
                                  if (dateString) {
                                    setFilters({
                                      ...filters,
                                      dueDate: dateString,
                                    });
                                  } else {
                                    setFilters({
                                      ...filters,
                                      dueDate: null,
                                    });
                                  }
                                }}
                                value={
                                  filters?.dueDate
                                    ? moment(filters?.dueDate)
                                    : null
                                }
                              />
                            </div>
                          ) : filter?.value === "weeklyDuration" ? (
                            <div className={styles.filterSelected_content}>
                              <Select
                                suffixIcon={<ArrowDown />}
                                className={styles.filterSelect}
                                getPopupContainer={(trigger) => trigger.closest(".criteria_popover")?.parentElement}
                                placeholder="Select Weekly Duration"
                                mode="multiple"
                                optionLabelProp="label"
                                onChange={(value) => {
                                  if (value && value.length > 0) {
                                    setFilters({
                                      ...filters,
                                      weeklyDuration: value,
                                    });
                                  } else {
                                    setFilters({
                                      ...filters,
                                      weeklyDuration: [],
                                    });
                                  }
                                }}
                                value={filters?.weeklyDuration}
                              >
                                {durationList.map((count, index) => (
                                  <Select.Option
                                    key={index}
                                    value={count.value}
                                    label={count.key}
                                  >
                                    {count.key}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                          ) : filter?.value === "assignedTo" ? (
                            <div className={styles.filterSelected_content}>
                              <Select
                                suffixIcon={<ArrowDown />}
                                getPopupContainer={(trigger) => trigger.closest(".criteria_popover")?.parentElement}
                                placeholder="Select Assignee"
                                style={{
                                  width: "100%",
                                  border: "1px solid #E5E5E5",
                                }}
                                onChange={(value) => {
                                  if (value && value.length > 0) {
                                    // Get the selected users from AssignOptions
                                    const selectedUsers = value
                                      .map((userId) => {
                                        const user = AssignOptions.find(
                                          (option) => option.value === userId
                                        );
                                        return user;
                                      })
                                      .filter(Boolean);

                                    setFilters({
                                      ...filters,
                                      assignedTo: selectedUsers,
                                    });
                                  } else {
                                    setFilters({
                                      ...filters,
                                      assignedTo: [],
                                    });
                                  }
                                }}
                                mode="multiple"
                                optionLabelProp="label"
                                filterOption={(input, option) =>
                                  option.children
                                    ?.toLowerCase()
                                    ?.includes(input?.toLowerCase())
                                }
                                value={
                                  filters?.assignedTo
                                    ? filters.assignedTo.map(
                                        (user) => user.value
                                      )
                                    : []
                                }
                                tagRender={(props) => {
                                  const { value, closable, onClose } = props;
                                  // Find the user by value
                                  const user = AssignOptions.find(
                                    (u) => u.value === value
                                  );
                                  const initials = user?.initials || value;
                                  return (
                                    <span className={styles.antdAssigneeBox}>
                                      {initials}
                                      {closable && (
                                        <span
                                          className={styles.antdAssigneeClose}
                                          onClick={onClose}
                                        >
                                          ×
                                        </span>
                                      )}
                                    </span>
                                  );
                                }}
                              >
                                {AssignOptions.map((option, index) => {
                                  const selectedUser =
                                    option?.label == filters?.assignedTo;

                                  return (
                                    <Select.Option
                                      key={index}
                                      value={option.value}
                                      style={{
                                        backgroundColor: selectedUser
                                          ? "#e6f7ff"
                                          : "#fff",
                                      }}
                                    >
                                      {option.label}
                                    </Select.Option>
                                  );
                                })}
                              </Select>
                            </div>
                          ) : filter?.value === "progress" ? (
                            <div className={styles.filterSelected_content}>
                              <Select
                                getPopupContainer={(trigger) => trigger.closest(".criteria_popover")?.parentElement}
                                placeholder="Select Progress"
                                suffixIcon={<ArrowDown />}
                                className={styles.filterSelect}
                                mode="multiple"
                                optionLabelProp="label"
                                onChange={(value) => {
                                  if (value && value.length > 0) {
                                    setFilters({
                                      ...filters,
                                      progress: value,
                                    });
                                  } else {
                                    setFilters({
                                      ...filters,
                                      progress: [],
                                    });
                                  }
                                }}
                                value={filters?.progress}
                              >
                                {actionItemWeightOptions.map(
                                  (option, index) => (
                                    <Select.Option
                                      key={index}
                                      value={option.value}
                                      label={option.label}
                                    >
                                      {option.label}
                                    </Select.Option>
                                  )
                                )}
                              </Select>
                            </div>
                          ) : (
                            <div className={styles.filterSelected_content}>
                              <Select
                                getPopupContainer={(trigger) => trigger.closest(".criteria_popover")?.parentElement}
                                placeholder="Select Weight"
                                suffixIcon={<ArrowDown />}
                                className={styles.filterSelect}
                                mode="multiple"
                                optionLabelProp="label"
                                onChange={(value) => {
                                  if (value && value.length > 0) {
                                    setFilters({
                                      ...filters,
                                      weight: value,
                                    });
                                  } else {
                                    setFilters({
                                      ...filters,
                                      weight: [],
                                    });
                                  }
                                }}
                                value={filters?.weight}
                              >
                                {actionItemWeightOptions.map(
                                  (option, index) => (
                                    <Select.Option
                                      key={index}
                                      value={option.value}
                                      label={option.label}
                                    >
                                      {option.label}
                                    </Select.Option>
                                  )
                                )}
                              </Select>
                            </div>
                          )}
                        </div>
                      ))}

                      {(selectedFilters.length === 0 || isNewFilter) && (
                        <div className={styles.filterSelect_box}>
                          <label htmlFor="">Select Filter</label>

                          <Select
                            options={removeFilterOption}
                            suffixIcon={<ArrowDown />}
                            className={styles.filterSelect}
                            getPopupContainer={(trigger) => trigger.closest(".criteria_popover")?.parentElement}
                            onChange={(value) => {
                              const selectedFilter =
                                actionItemFilterOptions.find(
                                  (option) => option.value === value
                                );

                              // Initialize the filter with empty array instead of null
                              const initialFilterValue =
                                selectedFilter.value === "status" ||
                                selectedFilter.value === "weight" ||
                                selectedFilter.value === "progress" ||
                                selectedFilter.value === "assignedTo" ||
                                selectedFilter.value === "weeklyDuration"
                                  ? []
                                  : null;

                              setSelectedFilters([
                                ...selectedFilters,
                                selectedFilter,
                              ]);

                              setFilters({
                                ...filters,
                                [value]: initialFilterValue,
                              });

                              setIsNewFilter(false);
                            }}
                          />
                        </div>
                      )}

                      {!(selectedFilters.length === 0 || isNewFilter) && (
                        <div
                          className={styles.AddFiler}
                          onClick={() => {
                            setIsNewFilter(true);
                          }}
                        >
                          <AddIcon /> Add Filter
                        </div>
                      )}
                    </div>

                    <div className={styles.actionButton}>
                      <button
                        onClick={() => {
                          // Close filter panel
                          setIsFilter(false);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleApply}
                        disabled={!hasActiveFilters()}
                        style={{
                          opacity: hasActiveFilters() ? 1 : 0.5,
                          cursor: hasActiveFilters()
                            ? "pointer"
                            : "not-allowed",
                        }}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </>
              }
              trigger="click"
              getPopupContainer={(trigger) => trigger.parentElement}
              placement="bottomRight"
              overlayClassName={"criteria_popover"}
              open={isFilter}
              onOpenChange={(value) => {
                if (value) {
                  // When opening, set selected filters based on current filterBy
                  const activeFilters = mapFiltersToOptions(filterBy);
                  setSelectedFilters(activeFilters);
                  setFilters({ ...filterBy });
                } else {
                  // When closing by clicking outside, reset filters
                  setSelectedFilters([]);
                  setFilters({ ...EMPTY_FILTERS });
                }
                setIsFilter(value);
              }}
            >
              <div
                className={`${styles.filterButton} ${
                  isFilter ? styles.filterButtonActive : ""
                }`}
                onClick={() => {
                  if (!isFilter) {
                    const activeFilters = mapFiltersToOptions(filterBy);
                    setSelectedFilters(activeFilters);
                    setFilters(filterBy);
                  }
                  setIsFilter(!isFilter);
                }}
              >
                <FilterIcon width={12} height={14} /> Filter
              </div>
            </Popover>

            {/*

          <Dropdown
            overlayClassName="listAndCardView_dropdown"
            menu={{
              items: [
                {
                  label: "List View",
                  icon: <ListViewIcon />,
                  onClick: () => setIsListView(true),
                },
                {
                  label: "Card View",
                  icon: <CardViewIcon />,
                  onClick: () => setIsListView(false),
                },
              ],
            }}
            trigger={["click"]}
            showArrow={true}
          >
            <span className={styles.view}>
              {isListView ? <ListViewIcon /> : <CardViewIcon />}{" "}
              {isListView ? "List View" : "Card View"}
              <DownOutlined />
            </span>
          </Dropdown> */}

            {/* <div className={styles.searchWrapper}>
            <SearchIcon className={styles.icon} width={20} />

            <input
              type="text"
              className={styles.search}
              placeholder={"Search projects"}
              value={search}
              onChange={handleSearch}
            />
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default PlanNewHeader;
